module.exports = __webpack_public_path__ + "static/media/1.bdbb0c36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/Teafloor/1.jpg
// module id = 360
// module chunks = 0